import axios from 'axios'
import { OrderSummaryType } from 'common/types/OrderSummaryType'

export function getOrderSummary(id: number) {
  return axios.get<OrderSummaryType>(`/api/payment/order/summary/${id}`)
}
